<script>
import OrganizationCreationDialog from '@/components/profile/tabs/OrganizationCreationDialog.vue'
import EmployeeManagementTable from '@/components/profile/administrationManagement/EmployeeManagementTable.vue'
import InboxManagementTable from '@/components/profile/administrationManagement/inboxes/InboxManagementTable.vue'
import Invitation from '@/components/profile/administrationManagement/EmployeeManagementInvitationAndCSVExport.vue'
import InboxCreateDialog from '@/components/profile/administrationManagement/inboxes/InboxCreateDialog.vue'
import AdministrationManagementSettings
  from '@/components/profile/administrationManagement/settings/AdministrationManagementSettings.vue'

export default {
  components: {
    AdministrationManagementSettings,
    InboxCreateDialog, Invitation,
    InboxManagementTable, EmployeeManagementTable,
    OrganizationCreationDialog
  },
  data() {
    return {
      notification: {
        state: false,
        timeout: 3000,
        type: 'success',
        content: ''
      },
      selectedTab: 0,
      search: null,
      updateOrganization: false,
      userSettingsToggle: { state: false, item: {} }
    }
  },
  computed: {
    treeviewOrganizations() {
      let organizations = this.$store.getters.organizationsWithAdminPermissions

      if (this.search) {
        organizations = organizations?.filter(org => {
          const searchIsNumber = !isNaN(Number(this.search))

          return searchIsNumber
            ? org.OrganizationId === Number(this.search)
            : org.OrganizationName?.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      organizations = organizations.sort((a, b) =>
        a.OrganizationName?.localeCompare(b.OrganizationName)
      )

      const organizationMap = new Map()
      organizations.forEach(org => {
        organizationMap.set(org.OrganizationId, { ...org, children: [] })
      })

      const nestedOrganizations = []
      organizations.forEach(org => {
        if (org.ParentOrganizationId && organizationMap.has(org.ParentOrganizationId)) {
          organizationMap.get(org.ParentOrganizationId).children.push(organizationMap.get(org.OrganizationId))
        } else {
          nestedOrganizations.push(organizationMap.get(org.OrganizationId))
        }
      })
      return nestedOrganizations
    }
  },
  watch: {
    selectedTab() {
      if (this.selectedTab === undefined || this.selectedTab === null) {
        return this.selectedTab = 1
      }
    }
  },
  mounted() {
    if (this.$store.getters.organizationsWithAdminPermissions.length > 0) {
      this.$store.commit('SET_SELECTED_ORGANIZATION', this.$store.getters.organizationsWithAdminPermissions[0])
    }
  },
  methods: {
    pickOrganization(selected) {
      if (selected[0]) {
        delete selected[0].children // necessary to remain reactivity globally
        this.$store.commit('SET_SELECTED_ORGANIZATION', selected[0])
        this?.$refs?.employeeManagementTable?.getInvitedPeople()
        this?.$refs?.inboxManagementTable?.getInboxesList()
      }
    },
    renameAndPersist() {
      this.updateOrganization = false
      this.$store.dispatch('renameOrganization', {
        id: this.$store.getters.selectedOrganization.OrganizationId,
        name: this.$store.getters.selectedOrganization.OrganizationName
      })
    },
    showNotification(type, content) {
      this.notification.state = true
      this.notification.type = type
      this.notification.content = content
    },
    onInvited() {
      this?.$refs?.employeeManagementTable?.getInvitedPeople()
      && this.$refs.employeeManagementTable.getInvitedPeople()
      return this.showNotification('success',
        this.$t('page.resellerManagement.user.invited.success')
      )
    },
    onInboxCreated() {
      this?.$refs?.inboxManagementTable?.getInboxesList()
      && this.$refs.inboxManagementTable.getInboxesList()
      return this.showNotification('success',
        this.$t('page.resellerManagement.inbox.created.success')
      )
    },
    onCreateOrganization() {
      return this.showNotification('success',
        this.$t('page.resellerManagement.organization.created.success')
      )
    },
    onErrorCreatingOrganization() {
      return this.showNotification('error',
        this.$t('page.resellerManagement.organization.creation.error')
      )
    },
    onUserSettingsToggle(event) {
      this.userSettingsToggle = event
    }
  }
}
</script>
<template>
  <v-container fluid>
  <v-card>
    <AdministrationManagementSettings v-model="userSettingsToggle" />
    <v-snackbar
      v-model="notification.state"
      :color="notification.type"
      :timeout="notification.timeout"
      top>
      <span v-html="notification.content" />
      <v-btn color="white" text @click="notification.state = false">
        <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-container fluid>
      <v-row>
        <v-col cols="2">
          <v-row>
            <v-col cols="10">
              <v-text-field
                v-model="search"
                :label="$t('page.resellerManagement.search.organization.label')"
                flat
                hide-details
                prepend-inner-icon="mdi-magnify"
                clearable
                clear-icon="mdi-close-circle-outline">
              </v-text-field>
            </v-col>
            <v-col cols="2" class="align-content-end">
              <OrganizationCreationDialog
                @created-organization="onCreateOrganization"
                @error-creating-organization="onErrorCreatingOrganization"
              />
            </v-col>
          </v-row>
          <v-treeview
            :items="treeviewOrganizations"
            activatable
            selection-type="independent"
            dense
            hoverable
            active-class="isActive"
            return-object
            item-key="OrganizationId"
            @update:active="pickOrganization">
            <template #prepend="{ open,item }">
              <v-icon v-if="$store.getters.selectedOrganization && item.hasOwnProperty('OrganizationName')">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
            </template>
            <template #label="{item}">
              <span
                v-if="$store.getters.selectedOrganization && item.hasOwnProperty('OrganizationName')"
                :class="$store.getters.selectedOrganization.OrganizationId && $store.getters.selectedOrganization.OrganizationId === item.OrganizationId ? 'isActive' : ''"
                :title="item.id">
                <small class="organization-id-prefix">{{ item.OrganizationId }}:</small> {{ item.OrganizationName }}
              </span>
            </template>
          </v-treeview>
        </v-col>
        <v-col cols="10" class="mt-2 pl-8 pr-8">
          <v-row no-gutters>
            <v-col cols="8">
              <div v-if="!updateOrganization">
                <h2 class="mt-1">{{ $store.getters.selectedOrganization.OrganizationName }}
                  <v-icon
                    v-if="$store.getters.selectedOrganization.IsAdmin"
                    class="mb-2"
                    @click.prevent.stop="updateOrganization = !updateOrganization">mdi-pencil
                  </v-icon>
                </h2>
              </div>
              <v-text-field
                v-else
                id="organizationNameUpdater"
                v-model="$store.getters.selectedOrganization.OrganizationName"
                :label="$t('page.resellerManagement.organization.name.label')"
                outlined
                dense
                required
              />
            </v-col>
            <v-col
              v-if="updateOrganization"
              cols="4">
              <v-btn
                color="primary"
                class="ms-1 me-1"
                @click="renameAndPersist">
                {{ $t('button.confirm') }}
              </v-btn>
              <v-btn @click="updateOrganization = false">
                {{ $t('button.cancel') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-10">
            <v-col>
              <v-btn-toggle
                v-model="selectedTab">
                <v-btn
                  v-if="$store.getters.selectedOrganization.IsAdmin"
                  class="pe-3">
                  <v-icon>mdi-account</v-icon>
                  {{ $t('button.user') }}
                </v-btn>
                <v-btn
                  v-if="$permissions.hasInput && $store.getters.selectedOrganization.IsAdmin"
                  class="pe-3">
                  <v-icon>mdi-inbox</v-icon>
                  {{ $t('button.inboxes') }}
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col>
              <InboxCreateDialog
                v-if="selectedTab === 1 && $permissions.hasInput && $store.getters.selectedOrganization.IsAdmin"
                class="text-end ma-0 pa-0"
                @created="onInboxCreated" />
              <Invitation
                v-if="selectedTab === 0 && $store.getters.selectedOrganization.IsAdmin"
                class="text-end ma-0 pa-0"
                @invited="onInvited" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <InboxManagementTable
                v-if="selectedTab === 1 && $permissions.hasInput && $store.getters.selectedOrganization.IsAdmin"
                ref="inboxManagementTable"
              />
              <EmployeeManagementTable
                v-if="selectedTab === 0 && $store.getters.selectedOrganization.IsAdmin"
                ref="employeeManagementTable"
                @onUserSettingsToggle="onUserSettingsToggle" />
            </v-col>
          </v-row>
          <v-row v-if="$store.getters.organizations.length > 0 && !$store.getters.selectedOrganization.IsAdmin">
            <v-col>
              <v-banner
                elevation="2"
                color="primary"
                outlined
                icon-color="white"
                icon="mdi-information">
                {{ $t('page.resellerManagement.no.admin.banner') }}
              </v-banner>
            </v-col>
          </v-row>
          <v-row v-if="$store.getters.organizations.length === 0">
            <v-col>
              <v-banner
                elevation="2"
                color="primary"
                outlined
                icon-color="white"
                icon="mdi-information">
               {{$t('page.resellerManagement.add.organization.banner')}}
              </v-banner>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
  </v-container>
</template>
<style scoped>
.isActive {
  font-weight: 800;
}

.organization-id-prefix {
  font-size: 12px;
  font-weight: 300;
}
</style>
